import IconStarEmpty from '@adv-mt/mt-svg-icons/lib/StarEmpty'
import IconStarFilled from '@adv-mt/mt-svg-icons/lib/StarFilled'
import IconStarHalf from '@adv-mt/mt-svg-icons/lib/StarHalf'

export const customStarIcons = {
  IconStarFilled,
  IconStarHalfFilled: IconStarHalf,
  IconStarEmpty
}

export const filterName = 'adjetive'
export const LEGEND_STEP_2 = 'Selector de adjetivos'
export const ID_COMMENT_FORM_DEALER_RATING = 'comment_form_dealer_rating'
